export type Inhabitants = 'BELOW_30000' | 'BELOW_45000' | 'BELOW_60000' | 'BELOW_100000' | 'ABOVE_100000';

export const InhabitantsLabels: { [x in Inhabitants]: string } = {
  BELOW_30000: '住民数 30,000人未満',
  BELOW_45000: '住民数 30,000～44,999人',
  BELOW_60000: '住民数 45,000～59,999人',
  BELOW_100000: '住民数 60,000～99,999人',
  ABOVE_100000: '住民数 100,000人以上',
};

export const InhabitantsKeys: { [x in Inhabitants]: x } = {
  BELOW_30000: 'BELOW_30000',
  BELOW_45000: 'BELOW_45000',
  BELOW_60000: 'BELOW_60000',
  BELOW_100000: 'BELOW_100000',
  ABOVE_100000: 'ABOVE_100000',
};

export const InhabitantsOrder: Inhabitants[] = ['BELOW_30000', 'BELOW_45000', 'BELOW_60000', 'BELOW_100000', 'ABOVE_100000'];
